'use client';
import React, { FC } from 'react';

import { ListResponse } from '@/api/types';
import { useSlide } from '@/hooks/useSlide';
import { useTranslation } from '@/hooks/useTranslations';

import TeamMember from './TeamMember';
import './styles.scss';

export type TeamMemberType = {
  id: ID;
  logo: string;
  email: string;
  lastname: string;
  position: string;
  firstname: string;
  bgColor: string | null;
};

interface OurTeamprops {
  team?: ListResponse<TeamMemberType>;
  title?: string;
  membersList?: TeamMemberType[];
  isEventMember?: boolean;
}

const OurTeam: FC<OurTeamprops> = ({
  team,
  membersList,
  isEventMember,
  title = 'Contactus-Oursalesteam-Title',
}) => {
  const { t } = useTranslation();
  const { onSlideLeft, onSlideRight } = useSlide({
    blockClassName: 'ourTeamCardWrp',
    containerId: 'wrapper',
  });

  return (
    <>
      <div className="ourTeamWrapper" id="team">
        <div className="bigContent">
          <div className="ourTeamInner">
            <div className="ourTeamTitleRow">
              <h2 className="ourTeamTitleText">{t(title)}</h2>
              <div className="ourTeamTitleButtonsCont">
                <div className="ourTeamTitleButtonsCase" onClick={onSlideLeft}>
                  <i className="bc-i-arrow-left ourTeamIconMobile" />
                </div>
                <div className="ourTeamTitleButtonsCase" onClick={onSlideRight}>
                  <i className="bc-i-arrow-right ourTeamIconMobile" />
                </div>
              </div>
            </div>
            <div className="ourTeamContentWrapper">
              <div className="ourTeamContentInner" id="wrapper">
                {isEventMember
                  ? membersList?.map((item) => <TeamMember key={item.firstname} member={item} />)
                  : team?.query.map((item) => <TeamMember key={item.firstname} member={item} />)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurTeam;
